<div class="inbox-chat" *ngIf="currentConversationDetail$ | async as currentConversationDetail">
  <inbox-messages-top-bar
    [accountGroupId]="accountGroupId() ?? ''"
    [groupId]="groupId() ?? ''"
    [unseen]="(unseen$ | async) ?? unseenDefault"
    [isFollowing]="(isFollowing$ | async) ?? false"
    [isOpen]="isOpen()"
    (markedUnread)="updateReadStatus($event)"
    (changeFollowStatus)="updateFollowStatus($event)"
    (changeOpenStatus)="updateOpenStatus($event)"
  ></inbox-messages-top-bar>
  <ng-container *ngIf="(isOpenAIChannel$ | async) === false">
    <glxy-alert
      *ngFor="let bannerText of banners$ | async"
      class="availibility-banner"
      [border]="true"
      [borderRadius]="false"
      type="tip"
    >
      {{ bannerText }}
    </glxy-alert>
  </ng-container>
  <ng-container *ngIf="showContactAlert$ | async">
    <ng-container [ngSwitch]="emailChannelSupported$ | async">
      <glxy-alert
        *ngSwitchCase="true"
        class="availibility-banner"
        [border]="true"
        [borderRadius]="false"
        [showAction]="true"
        [actionTitle]="'INBOX.SENDER.VIEW_CONTACT' | translate"
        (actionClick)="viewContact()"
        type="error"
      >
        {{ 'INBOX.ERROR.NO_PHONE_NUMBER_OR_EMAIL' | translate }}
      </glxy-alert>
      <glxy-alert
        *ngSwitchCase="false"
        class="availibility-banner"
        [border]="true"
        [borderRadius]="false"
        [showAction]="true"
        [actionTitle]="'INBOX.SENDER.VIEW_CONTACT' | translate"
        (actionClick)="viewContact()"
        type="error"
      >
        {{ 'INBOX.ERROR.NO_PHONE_NUMBER' | translate }}
      </glxy-alert>
    </ng-container>
  </ng-container>
  <glxy-alert
    *ngIf="notificationWarningChat$ | async"
    type="info"
    [showAction]="true"
    actionTitle="{{ 'INBOX.WARNING.TURN_ON_NOTIFICATIONS' | translate }}"
    (actionClick)="openSettings()"
    [showClose]="true"
    (close)="onClose()"
    [border]="false"
    [borderRadius]="false"
    [stackedView]="viewModel ?? false"
  >
    <strong>{{ 'INBOX.WARNING.TURN_ON_NOTIFICATIONS' | translate }}</strong>
    {{ 'INBOX.WARNING.TURN_ON_NOTIFICATIONS_DETAILS' | translate }}
    <strong>{{ 'INBOX.WARNING.NOTIFICATION_SETTINGS' | translate }}</strong>
  </glxy-alert>
  <glxy-loading-spinner
    *ngIf="loadingMessages$ | async"
    [ngClass]="{ 'show-loading': (loadingMessages$ | async) }"
  ></glxy-loading-spinner>
  <inbox-messages
    *ngIf="currentConversationDetail$ | async as currentConversationDetail"
    [messages]="(messages$ | async) ?? []"
    [events]="(events$ | async) ?? []"
    [conversation]="currentConversationDetail.conversation"
  ></inbox-messages>
  <ng-container [ngSwitch]="!!disabledAlert()">
    <div *ngSwitchCase="true" class="alert-container">
      <glxy-alert
        [ngClass]="{ 'web-chat-alert-banner': (isWebChatConversation$ | async) }"
        type="tip"
        [showAction]="!!disabledAlert()?.action"
        [extendedBorder]="false"
        [actionTitle]="disabledAlert()?.action?.title ?? '' | translate"
        (actionClick)="disabledAlert()?.action?.callback()"
      >
        <strong [innerHtml]="disabledAlert()?.title ?? '' | translate"></strong>
        <glxy-alert-extended *ngIf="!!disabledAlert()?.description">
          {{ disabledAlert()?.description || '' | translate }}
        </glxy-alert-extended>
      </glxy-alert>
    </div>
    <ng-container *ngIf="currentConversationDetail$ | async as currentConversationDetail">
      <inbox-message-text
        #inboxTextComponent
        *ngSwitchCase="false"
        (sendMessage)="sendMessage($event)"
        (fileChange)="fileChange($event)"
        [clearMessageText]="(termsOfServiceResult$ | async)?.termsOfServiceAccepted"
        [conversationDetail]="currentConversationDetail"
        [availableChannels]="availableChannels$ | async"
        [isImpersonating]="(isImpersonating$ | async) ?? false"
        [prefilledMessage]="(inboxPrefilledMessage$ | async) ?? ''"
        [missingContactInformation]="(missingContactInformation$ | async) ?? true"
      ></inbox-message-text>
    </ng-container>
  </ng-container>
</div>
